import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { _ } from "../../utils/helpers";
import { DEFAULT_DIALOG_HANDLE} from "../../utils/symbols";
import { useApp } from "../../context/useApp";

interface LoadingDialogProps {
    dialogData: DialogData
}

export const LoadingDialog: FC<LoadingDialogProps> = ({dialogData}) => {

    if (dialogData.dialog !== 'loading') return null

    return (
        <section 
            className={`df fd-c aifs jcfs r3 section p-r`}
            aria-label={_('0ge_loadi__')}
        >
            <span className="loader"></span>
        </section>
    )
}